import axios from 'axios';

const state = {
  user: {}
};

const getters = {
  detailUser: (state) => state.user
};

const actions = {
  async fetchUser({ commit }) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/auto-login`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.data;
      commit('setUser', data);
    }
    catch (error) {
      console.error('Failed to fetch user: ', error)
    }
  },
  async updateUser({ commit }, userData) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.put(`${process.env.VUE_APP_ROOT_API}/users/${userData.id}`, userData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = response.data;
      commit('setUser', data);
      return data;
    }
    catch (error) {
      console.error('Failed to update user: ', error);
      throw error;
    }
  },
  async changePassword({ commit }, dataPassword ) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.put(`${process.env.VUE_APP_ROOT_API}/users/${dataPassword.id}`, dataPassword, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = response.data;
      commit('setUser', data);
      return data;
    }
    catch (error) {
      console.error('Failed to change password: ', error);
      throw error;
    }
  }
};

const mutations = {
  setUser(state, user) {
    state.user = user.data;
  }
};

export default {
  namespaced: true,
  state, mutations, actions, getters
}